import { createContext } from 'react';

export interface GlobalContextProps {
  featureFlags: {};
}

export const GlobalContext = createContext<GlobalContextProps>({
  featureFlags: {},
});
